.viewport {
  position: fixed;
  right: var(--space-4);
  bottom: var(--space-4);
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  width: min(24rem, calc(100vw - 2 * var(--space-4)));
  pointer-events: none;
}

.region {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.toast {
  --toast-accent: var(--color-info-fg);

  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-3) var(--space-3) var(--space-4);
  border: 1px solid var(--color-border);
  border-left: 4px solid var(--toast-accent);
  border-radius: var(--radius-lg);
  background-color: var(--color-surface-raised);
  box-shadow: var(--shadow-lg);
  color: var(--color-text);
  pointer-events: auto;
  animation: toast-in var(--duration-slow) var(--ease-out);
}

.success {
  --toast-accent: var(--color-success-fg);
}

.warning {
  --toast-accent: var(--color-warning-fg);
}

.error {
  --toast-accent: var(--color-danger-fg);
}

.icon {
  display: inline-flex;
  flex-shrink: 0;
  margin-top: 0.0625rem;
  color: var(--toast-accent);
}

.content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.title {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-snug);
  overflow-wrap: anywhere;
}

.description {
  color: var(--color-text-muted);
  font-size: var(--font-size-sm);
}

.action {
  align-self: flex-start;
  margin-top: var(--space-1);
  color: var(--color-link);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
}

.action:hover {
  text-decoration: underline;
}

.close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: var(--radius-sm);
  color: var(--color-text-muted);
}

.close:hover {
  background-color: var(--color-surface-hover);
  color: var(--color-text);
}

.closeIcon {
  transform: rotate(45deg);
}

@keyframes toast-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
}

@media (max-width: 480px) {
  .viewport {
    right: var(--space-2);
    left: var(--space-2);
    bottom: var(--space-2);
    width: auto;
  }
}
